import solicitacoesRoutes from './solicitacoes/rotas.js';
import solicitacoesRotasDispensaInexigibilidade from './solicitacoes/dispensaouinexigibilidade/rotas';

const routes = {
    path: 'licitacoes',
    name: 'Licitacoes',
    component: () => import('./Licitacao.vue'),
    children: [...solicitacoesRoutes, ...solicitacoesRotasDispensaInexigibilidade],
    meta: {
        rules: ['LICITACOES-00'],
    },
};

export default routes;
